import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _statusIcons;

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';
import CircularProgress from '@material-ui/core/CircularProgress';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import Grid from '@material-ui/core/Grid';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import Typography from '@material-ui/core/Typography';
import { PENDING, REJECTED, RESOLVED } from './constants';
var useStyles = makeStyles(function (_ref) {
  var palette = _ref.palette;
  return {
    icon: {
      position: 'relative',
      width: '48px'
    },
    fabProgress: {
      color: palette.secondary.main,
      position: 'absolute',
      top: -4,
      left: -4,
      zIndex: 1
    }
  };
});
var statusIcons = (_statusIcons = {}, _defineProperty(_statusIcons, RESOLVED, {
  icon: CheckIcon,
  color: 'primary'
}), _defineProperty(_statusIcons, PENDING, {
  icon: HourglassEmptyIcon,
  color: 'disabled'
}), _defineProperty(_statusIcons, REJECTED, {
  icon: ErrorOutline,
  color: 'error'
}), _statusIcons);
/**
 * Component to evaluate status and display messages
 */

export default function CircularIntegration(_ref2) {
  var status = _ref2.status,
      error = _ref2.error,
      message = _ref2.message,
      externalError = _ref2.externalError;
  var classes = useStyles();
  var Icon = statusIcons[status].icon;
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    alignItems: "center",
    direction: "row",
    zeroMinWidth: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: classes.icon
  }, /*#__PURE__*/React.createElement(Icon, {
    color: statusIcons[status].color,
    fontSize: "large"
  }), status === PENDING && !externalError && /*#__PURE__*/React.createElement(CircularProgress, {
    size: 42,
    className: classes.fabProgress
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1"
  }, "".concat(status, " ").concat(error ? error : message))));
}